export default __webpack_public_path__ + "static/media/landing-agent-feature-2.117e056d.svg";